<template>
  <div class="mt-10">
    <div class="bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
      <div class="md:grid md:grid-cols-3 md:gap-6">
        <div class="md:col-span-1">
          <h3 class="text-lg font-medium leading-6 text-gray-900">
            Automated abandoned cart messages
          </h3>
          <p class="mt-1 text-sm leading-5 text-gray-500">
            Configure whatsapp by adding your number
          </p>
          <div></div>
        </div>
        <div
          v-if="config.additionalAbandonedCartReminder"
          class="mt-5 md:mt-0 md:col-span-2"
        >
          <form @submit="handleSubmit">
            <fieldset>
              <legend class="text-base leading-6 font-medium text-gray-900">
                Enable automation
              </legend>

              <div class="mt-4 flex flex-wrap">
                <VSwitch
                  :value="config.additionalAbandonedCartReminder.isEnabled"
                  @input="handleSwitch"
                />
              </div>
              <p class="mt-2 text-sm text-gray-500">
                Automated WhatsApp messages are sent from our approved WhatsApp
                Business API number.
              </p>
            </fieldset>
            <div class="grid grid-cols-3 gap-6 mt-5">
              <div class="col-span-3 sm:col-span-2">
                <div>
                  <label
                    for="phone_number"
                    class="block text-sm font-medium leading-5 text-gray-700"
                  >
                    Phone Number
                  </label>
                  <div class="mt-1 relative rounded-md shadow-sm">
                    <vue-tel-input
                      :value="phoneNumber"
                      mode="international"
                      :disabledFetchingCountry="true"
                      @input="handlePhoneNumberUpdate"
                    />
                    <p class="mt-2 text-sm text-gray-500">
                      We will share this number as a link where customers can
                      reply to you if they have any concerns.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-span-3 sm:col-span-2">
              <div>
                <label
                  for="company-website"
                  class="block text-sm font-medium text-gray-700"
                >
                  Abandoned cart timing
                </label>
                <div class="mt-1 flex rounded-md shadow-sm">
                  <input
                    type="number"
                    name="company-website"
                    id="company-website"
                    class="flex-1 min-w-0 block w-full px-3 py-2 rounded-none rounded-l-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 border"
                    placeholder="number between 1 - 24"
                    v-model="
                      config.additionalAbandonedCartReminder.sendAfterHours
                    "
                  />
                  <div
                    class="inline-flex items-center px-3 rounded-r-md border border-l-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm"
                  >
                    Hours after checkout abandoned
                  </div>
                </div>
              </div>
            </div>
            <div class="grid grid-cols-3 gap-6 mt-5">
              <div class="col-span-3 sm:col-span-2">
                <label
                  for="location"
                  class="block text-sm leading-5 font-medium text-gray-700"
                  >Language</label
                >
                <select
                  id="location"
                  class="mt-1 form-select block w-full pl-3 pr-10 py-2 text-base leading-6 border-gray-300 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5"
                  v-model="config.messageLanguage"
                >
                  <option
                    v-for="(language, index) in templates"
                    :key="index"
                    :value="language.elementName"
                    >{{ language.name }}</option
                  >
                </select>
              </div>
            </div>
            <div class="mt-6">
              <label
                for="about"
                class="block text-sm leading-5 font-medium text-gray-700"
              >
                Message
              </label>
              <div class="rounded-md shadow-sm">
                <textarea
                  id="about"
                  rows="8"
                  class="form-textarea mt-1 block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5 cursor-not-allowed bg-gray-100"
                  :value="currentTemplate"
                  :disabled="true"
                ></textarea>
              </div>
            </div>
            <div class="mt-4 sm:mt-0 sm:col-span-2">
              <div class="max-w-lg mt-5">
                <div class="relative flex items-start">
                  <div class="flex items-center h-5">
                    <input
                      id="comments"
                      type="checkbox"
                      v-model="config.includeDiscountCoupon"
                      class="form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
                    />
                  </div>
                  <div class="ml-3 text-sm leading-5">
                    <label for="comments" class="font-medium text-gray-700"
                      >Include coupon code</label
                    >
                    <div
                      class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start  sm:pt-5"
                    >
                      <div class="sm:col-span-3">
                        <label
                          for="first_name"
                          class="block text-sm font-medium leading-5 text-gray-700"
                        >
                          Coupon code
                        </label>
                        <div class="mt-1 rounded-md shadow-sm">
                          <input
                            id="first_name"
                            class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                            v-model="config.couponCode"
                            placeholder="10OFFNEW"
                          />

                          <p class="mt-2 text-sm text-gray-500">
                            Create coupon codes from your
                            <a
                              class="text-blue-700"
                              :href="discountUrl"
                              target="_blank"
                              >Shopify admin > Discounts</a
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-8 border-t border-gray-200 pt-5">
                <div class="flex justify-end">
                  <span class="ml-3 inline-flex rounded-md shadow-sm">
                    <button
                      type="submit"
                      class="inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out"
                      @click="save"
                    >
                      Save
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <Notification :text="notificationText" :show="showNotification" />
      <OptinOnboardingModal v-if="showModal" @close="showModal = false" />
    </div>
    <div class="bg-white shadow sm:rounded-lg my-5">
      <div class="px-4 py-5 sm:p-6">
        <h3 class="text-lg leading-6 font-medium text-gray-900">
          Recover more sales by collecting WhatsApp opt-in from Checkout page
          (Mandatory)
        </h3>
        <div class="mt-2 sm:flex sm:items-start sm:justify-between">
          <div class="max-w-xl text-sm leading-5 text-gray-500">
            <p>
              Complete the steps in the guide and apply for approval. We will
              manually check your store checkout page to verify the changes.
            </p>
          </div>
          <div
            class="mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center"
          >
            <span class="inline-flex rounded-md shadow-sm">
              <button
                type="button"
                class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150"
                @click="openOptinModal"
              >
                View guide
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueTelInput } from "vue-tel-input";
import VSwitch from "../../components/Common/VSwitch";

import Notification from "../../components/Common/Notification";
import OptinOnboardingModal from "../../components/Common/OptinOnboardingModal.vue";

export default {
  name: "AutomatedConfigureForm",
  components: {
    VueTelInput,
    VSwitch,
    Notification,
    OptinOnboardingModal
  },

  data() {
    return {
      phoneNumber: "",
      notificationText: "",
      showNotification: false,
      config: {},
      templates: [],
      showModal: false
    };
  },
  computed: {
    currentTemplate() {
      const template = this.templates.find(
        template => template.elementName === this.config.messageLanguage
      );
      if (template && template.variables) {
        for (const variable of template.variables) {
          template.message = template.message.replace(
            variable.variable,
            variable.replacingElement
          );
        }
      }

      return template?.message;
    },
    discountUrl() {
      const { shopOrigin } = this.$store.getters.getStore;
      return `https://${shopOrigin}/admin/discounts/`;
    }
  },
  created() {
    this.init();
    this.updateOnboadingFlag();
  },
  mounted() {},
  methods: {
    init() {
      this.isLoading = true;
      this.$store.dispatch("getAutomationConfig").then(response => {
        this.config = response.config;
        this.templates = response.templates;
        this.phoneNumber = this.config.phoneNumber;
        this.isLoading = false;
      });
    },
    handleSubmit(event) {
      event.preventDefault();

      console.log(this.phoneNumber);
    },
    handlePhoneNumberUpdate(phoneNumber, event) {
      // if (isValid) {
      // console.log(number, isValid, country);
      this.config.phoneNumber = event.number;
      // }
    },
    save() {
      if (this.hasMoreCharacters) {
        alert("Button Label should be less than 12 characters");
        return;
      }
      if (
        this.config.includeDiscountCoupon &&
        (!this.config.couponCode || this.config.couponCode.length == 0)
      ) {
        alert("Please add a discount code");
        return;
      }
      this.updateConfig();
    },
    handleSwitch(value) {
      this.config.additionalAbandonedCartReminder.isEnabled = value;
    },
    updateConfig() {
      if (
        this.config.additionalAbandonedCartReminder.sendAfterHours < 0 ||
        this.config.additionalAbandonedCartReminder.sendAfterHours > 24
      ) {
        alert("Timing should be betweent 1 to 24 hours");
        return;
      }
      const automationConfig = { ...this.config };
      this.$store
        .dispatch("updateAutomationConfig", { requestParams: automationConfig })
        .then(() => {
          this.displayNotification("settings updated");
        });
    },
    displayNotification(text) {
      this.showNotification = true;
      this.notificationText = text;
      setTimeout(() => {
        this.showNotification = false;
      }, 3000);
    },
    openOptinModal() {
      this.showModal = true;
    },
    updateOnboadingFlag() {
      this.$store.dispatch("updateOnboardingFlag", {
        requestParams: {
          flag: "isAutomatedAbandonedVisited"
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
